
import { Russian } from 'flatpickr/dist/l10n/ru.js';
import { Component, Prop, VModel, Vue, Watch } from 'vue-property-decorator';

// SVG
import CalendarSVG from '@/assets/calendar.svg';
import CrossSVG from '@/assets/cross.svg';

// Components
import VButtonIcon from '@/components/VButton/VButtonIcon.vue';

// Interfaces
import { DateTime } from 'luxon';

// Utils
import { isEmpty } from 'lodash';

@Component({
    components: { CalendarSVG, CrossSVG, VButtonIcon },
})
export default class VDatePicker extends Vue {
    @VModel({ type: String, default: '' })
    public date!: string | null;

    @Prop({ type: String, default: '' })
    public max!: string;

    @Prop({ type: String, default: '' })
    public min!: string;

    @Prop({ type: Boolean, default: false })
    public disabled!: boolean;

    @Prop({ type: Boolean, default: false })
    public error!: boolean;

    @Prop({ type: Boolean, default: false })
    public isClearable!: boolean;

    @Prop({ type: Boolean, default: true })
    public allowInvalidPreload!: boolean;

    @Prop({ type: String, default: '' })
    public id!: string;

    @Prop({ type: String, default: '' })
    public dateText!: string;

    @Prop({ type: Boolean, default: false })
    public isWeekendsDisabled!: boolean;

    @Prop({ type: Boolean, default: false })
    public enableTime!: boolean;

    @Prop({ type: Array, default: () => [] })
    disabledDates!: string[];

    // fix flatpickr reactivity: local value changing, when global value not apply this change
    public key: string | null = '';

    selected: unknown = null;

    public get config() {
        return {
            dateFormat: this.enableTime ? 'H:i' : 'd.m.Y',
            locale: Russian,
            maxDate: this.max,
            minDate: this.min,
            allowInvalidPreload: this.allowInvalidPreload,
            disable: this.isWeekendsDisabled ? [...this.disabledDates] : [],
            enableTime: this.enableTime,
            noCalendar: this.enableTime,
            minuteIncrement: 1,
        };
    }

    get isSelected() {
        return !isEmpty(this.selected);
    }

    get hasClearButton() {
        return this.isClearable && this.isSelected && !this.disabled;
    }

    public clearSelected() {
        this.selected = null;
        this.$emit('input', this.selected);
    }

    open() {
        this.$emit('open');
    }

    public inputHandler(value: string | null) {
        if (this.enableTime) return;

        this.key = value;
    }

    public formatDate(record: string | null): string | null {
        if (!record) return record;

        return record.includes('.') ? record : DateTime.fromFormat(record, 'yyyy-MM-dd').toFormat('dd.MM.yyyy');
    }

    public created() {
        this.date = this.formatDate(this.date);
        this.dateWatchHandler();
    }

    @Watch('date')
    public dateWatchHandler() {
        this.selected = this.date;
    }
}
